import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Stack } from '@alfa-bank/site-stack';

import { Item as Component } from '../components/item';
import styles from '../styles/desktop.css';
import type { TAccordionItemDeps, TAccordionItem } from '../models';

export const ItemDesktop = createWidget<TAccordionItemDeps, TAccordionItem>(
    { Stack, styles },
    { priorityStyler: true }
)(Component);
